// extracted by mini-css-extract-plugin
export default {"values__wrapper":"OurValues_values__wrapper__HPvEQ","item__wrapper":"OurValues_item__wrapper__S4-vG"};